import React, { useEffect, useState } from 'react'
import {
    Button,
    Modal,
    Pagination,
    Skeleton,
    Stack,
    TableCell,
    TableRow,
    Typography,
    Box
} from '@mui/material';
import { useProjectStore } from '../../store/useProjectStore'
import { Link, useNavigate, useParams } from 'react-router'
import { formatDate } from '../../lib/formateDate';
import Loader from '../../Components/Loader';
import TruncatedText from '../../Components/TruncatedText';

const DisplayProject = () => {
    const navigate = useNavigate()
    let { getProjectForProjectPage, project, deleteproduct } = useProjectStore()
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [field, setField] = useState('title');
    const [loading, setLoading] = useState('');
    const [itemId, setItemId] = useState('');
    const [open, setOpen] = useState('');

    const getProjectdata = async () => {
        setLoading(true)
        let res = await getProjectForProjectPage(pageNumber, pageSize, search, field)
        if (res) {
            setTotalPages(res?.totalPages);
        }
        setLoading(false)
    }

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleSearchChange = (e) => {
        setPageNumber(1)
        setLoading(true);
        setSearch(e)
    };

    const handleDelete = (id) => {
        setItemId(id)
        setOpen(true)
    }

    const handleCancelDelete = () => {
        setOpen(false);
    };


    const handleConfirmDelete = async () => {
        try {
            setOpen(false)
            setLoading(true)
            const res = await deleteproduct(itemId)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        getProjectdata()
    }, [pageNumber, search, field])
    return (
        <div>
            <div className="bg-white p-4 rounded-md shadow-sm border border-neutral-200 mb-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 justify-between w-full">
                        <div className="relative">
                            <input type="text"
                                placeholder="Search projects..."
                                className="pl-8 pr-4 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                value={search}
                                onChange={(e) => handleSearchChange(e.target.value)}
                            />
                            <i className="fa-solid fa-search absolute left-3 top-2.5 text-neutral-400 text-sm"></i>
                        </div>
                        {/* <Link to='/projects/order' class="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
                            Order the Projects
                        </Link> */}
                    </div>
                    {/* <div class="flex items-center space-x-2">
                        <button class="px-3 py-2 border border-neutral-300 rounded-md text-sm flex items-center">
                            <i class="fa-solid fa-filter mr-2"></i>
                            More Filters
                        </button>
                        <button class="px-3 py-2 border border-neutral-300 rounded-md text-sm flex items-center">
                            <i class="fa-solid fa-download mr-2"></i>
                            Export
                        </button>
                    </div> */}
                </div>
            </div>
            <Loader loading={loading}>
                {/* <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                    {
                        (project || []).map((ele, i) => (
                            <div id="project-1" class="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
                                <div class="relative h-48 bg-neutral-700 flex items-center justify-center rounded-lg overflow-hidden">
                                    <img
                                        src={ele?.image}
                                        alt="Project"
                                        class="w-full h-full object-cover"
                                    />
                                    <div class="absolute top-2 right-2 flex space-x-2">
                                        <Link to={`/projects/form?id=${ele?._id}`} class="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100">
                                            <i class="fa-solid fa-edit"></i>
                                        </Link>
                                        <button class="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100"
                                            onClick={() => handleDelete(ele?._id)}>
                                            <i class="fa-solid fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="p-4">
                                    <div class="flex justify-between items-center mb-2">
                                        <h3>{ele?.title}</h3>
                                        <span style={{ color: ele?.isFeatured ? 'green' : 'red' }}>
                                            {ele?.isFeatured ? 'Active' : 'In Active'}
                                        </span>

                                    </div>
                                    <div className="text-sm text-neutral-500 mb-2">
                                        {ele?.marketType}
                                    </div>

                                    <p class="text-sm text-neutral-600 mb-4">
                                        <TruncatedText text={ele?.description} limit={150} />
                                    </p>
                                    <div class="flex items-center justify-end text-sm text-neutral-500">

                                        <div>
                                            <i class="fa-solid fa-calendar mr-1"></i>
                                            {formatDate(ele?.createdAt)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                </div> */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-neutral-50 text-center text-xs text-neutral-500 uppercase tracking-wider">
                            <th className="px-6 py-3">Title</th>
                            <th className="px-6 py-3">Market Place</th>
                            <th className="px-6 py-3 w-[20%]">Description</th>
                            <th className="px-6 py-3">Date</th>
                            <th className="px-6 py-3">Status</th>
                            <th className="px-6 py-3">Order</th>
                            <th className="px-6 py-3 text-right">Actions</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-neutral-200 text-center">
                        {
                            (project || []).map((ele, i) => {
                                return (
                                    <tr className="hover:bg-neutral-50" key={i}>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10  flex items-center justify-center rounded-sm text-white text-xs mr-3">
                                                    <img src={ele?.image} alt="" className='rounded-sm' />
                                                </div>
                                                <span>{ele?.title}</span>
                                            </div>
                                        </td>
                                        <td>
                                            {ele?.marketType}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-neutral-600 w-[20%]">
                                            <TruncatedText text={ele?.description} limit={20} />
                                        </td>
                                        <td className="px-6 py-4 text-sm text-neutral-600 ">
                                            <i className="fa-solid fa-calendar mr-1"></i>
                                            {formatDate(ele?.createdAt)}
                                        </td>
                                        <td>
                                            <span style={{ color: ele?.isFeatured ? 'green' : 'red' }}>
                                                {ele?.isFeatured ? 'Active' : 'In Active'}
                                            </span>
                                        </td>
                                        <td>
                                            {ele?.order}
                                        </td>
                                        <td className="px-6 py-4 text-right text-sm">
                                            <Link to={`/projects/form?id=${ele?._id}`} class="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100">
                                                <i className="fa-solid fa-edit"></i>
                                            </Link>
                                            <button className="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100"
                                                onClick={() => handleDelete(ele?._id)}>
                                                <i className="fa-solid fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }

                    </tbody>
                </table>
            </Loader>

            <div className="flex justify-end items-center mb-6">
                <div className="flex justify-between items-center mb-6">
                    <Stack spacing={2} className="flex items-end mt-4">
                        <Pagination
                            count={totalPages}
                            onChange={handleChangePagination}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                "& .MuiPaginationItem-root": {
                                    color: "white",
                                    borderColor: "#000",
                                    backgroundColor: "#000",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "#333 !important",
                                    color: "white",
                                },
                                "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#444",
                                    color: "white",
                                },
                            }}
                        />
                    </Stack>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Project?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div >
    )
}

export default DisplayProject
